<div class="dialog-container">
  <div class="title-header">
    <span class="flex-1">{{ template.title }}</span>
    @if (languages.length > 1) {
      <app-language-selection size="20px" [(ngModel)]="selectedLanguage" [languages]="languages" [searchBar]="false" />
    }
    <button class="icon-close icon-button" mat-dialog-close="" type="button"></button>
  </div>
  <div class="container">
    @if (template?.sections) {
      <div class="scroll-container">
        @for (section of template.sections; track section) {
          <div class="preview-section-container">
            <!-- Section Title -->
            <div class="section-title-container">
              <div [innerHTML]="isEnglish ? section.title : section.titleDe" class="section-title"></div>
            </div>

            @for (area of section.areas; track area) {
              <div class="section-area">
                <!-- Question and Guidance -->
                <div [innerHTML]="isEnglish ? area.description : area.descriptionDe" class="description"></div>
                @if (area.guidanceText) {
                  <div class="guidance-area">
                    <label class="guidance-title">Guidance</label>
                    <div [innerHTML]="isEnglish ? area.guidanceText : area.guidanceTextDe" class="guidance-text"></div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <app-loading-indicator [delay]="100" backgroundColor="transparent" />
    }
  </div>
</div>
